
import axios from 'axios';
import React, { Component }  from 'react';


export class PreloadSchedule extends Component {

  constructor(props) {
    super(props);

    this.state = {
      loading: true
    }
  }

  componentDidMount() {
    const { id, onUpdate } = this.props;
    if (id) {
      axios.get(`schedule/${id}`).then(res => {
        const schedule = res.data;
        let newSchedule = {
          date_start: schedule.date_end,
          driver: schedule.driver,
          tractor_unit: schedule.tractor_unit,
          semi_trailer: schedule.semi_trailer
        };
        onUpdate(newSchedule);

        this.setState({
          loading: false
        })
      })
    }
    else {
      this.setState({
        loading: false
      });
    }

  }

  render() {
    const { loading } = this.state;
    if (loading)
      return <React.Fragment/>;

    return <React.Fragment>{this.props.children}</React.Fragment>
  }
}
